// @ts-strict-ignore
import { ChangeDetectionStrategy, Component, DestroyRef, HostListener, OnInit } from '@angular/core';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { ReportGenerationPropertyDef } from '@project/components/project/constants/report-generation-property-def';
import { ReportVO } from '@project/model/vo/report.vo';
import { SelectProjectReportService } from '../service/select-project-report.service';
import { SelectProjectReportModel } from './select-project-report.model';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UserModel } from '@user/model/user.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone: false,
  selector: 'app-select-project-report',
  templateUrl: './select-project-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectProjectReportComponent implements OnInit {

  public orderNumbersLabelFn = (item) => this.getOrderNumbersLabel(item);

  constructor(
    public exportModel: SelectProjectReportModel,
    private bsModalRef: BsModalRef,
    private selectProjectReportService: SelectProjectReportService,
    private userModel: UserModel,
    private localeResourceManager: LocaleResourceManager,
    private destroyRef: DestroyRef
  ) { }

  public ngOnInit(): void {
    this.exportModel.pdfConfirm.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.close());
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public next(): void {
    this.selectProjectReportService.next();
  }

  public getPaperSizeLabel(item: string): string {
    return this.selectProjectReportService.getPaperSizeLabel(item);
  }

  public getScaleLabel(item: number): string {
    return this.localeResourceManager.getValueByKey(SelectProjectReportService.LOCALE_PREFIX +
      ReportGenerationPropertyDef.SCALE + '.' + item);
  }

  public getOrderNumbersLabel(item: string): string {
    let label: string = this.localeResourceManager.getValueByKey(SelectProjectReportService.LOCALE_PREFIX +
      ReportGenerationPropertyDef.ORDER_NUMBERS + '.' + item);
    if (item === this.exportModel.customOrderNumbersKey) {
      const activeArticleNumberMappingListName: string = this.userModel.getActiveArticleNumberMappingListName();
      if (activeArticleNumberMappingListName) {
        label += ' (' + activeArticleNumberMappingListName + ')';
      }
    }
    return label;
  }

  public getReportSubtypeLabel(item: string): string {
    return this.localeResourceManager.getValueByKey(SelectProjectReportService.LOCALE_PREFIX +
      ReportGenerationPropertyDef.SUBTYPE + '.' + item);
  }

  public isReportScaleSelectionAvailable(report: ReportVO): boolean {
    return this.selectProjectReportService.isReportScaleSelectionAvailable(report);
  }

  public isReportSubtypeSelectionAvailable(report: ReportVO): boolean {
    return this.selectProjectReportService.isReportSubtypeSelectionAvailable(report);
  }

  public getReportSubtypeDataProvider(report: ReportVO): string[] {
    return this.selectProjectReportService.getReportSubtypeDataProvider(report);
  }

  public onReportsChange(): void {
    this.selectProjectReportService.onReportsChange();
  }

  public dataStructureGroupChange(value: string): void {
    this.selectProjectReportService.dataStructureGroupChange(value);
  }

  @HostListener('click', ['$event'])
  protected onClick($event: any) {
    $event.stopPropagation();
  }
}
